import { render, staticRenderFns } from "./CreateWorkRegistration.vue?vue&type=template&id=1e2700f6&"
import script from "./CreateWorkRegistration.vue?vue&type=script&lang=js&"
export * from "./CreateWorkRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports